import type { Locale } from '@/intl/types'
import { isValid, parseISO } from 'date-fns'
import { OverviewService } from '../../domain/types'

export function formatDate(dateString?: string, locale: Locale = 'nl-NL', monthFormat: 'short' | 'long' = 'short'): string {
  const normalizedDateString = dateString?.trim() || ''
  if (!normalizedDateString) {
    return ''
  }

  const date = parseISO(normalizedDateString)
  if (!isValid(date)) {
    return ''
  }
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: monthFormat,
    year: 'numeric',
  })
}

export interface ParticipantAge { unit: 'months' | 'years', count: number }
export function getParticipantAge(birthDate: string | undefined, referenceDate: Date = new Date()): ParticipantAge | null {
  if (!birthDate) {
    return null
  }

  const birth = parseISO(birthDate)

  if (!isValid(birth) || !isValid(referenceDate)) {
    return null
  }

  const years = referenceDate.getFullYear() - birth.getFullYear()
  const months = referenceDate.getMonth() - birth.getMonth()
  const days = referenceDate.getDate() - birth.getDate()
  const totalMonths = years * 12 + months + (days < 0 ? -1 : 0)

  if (totalMonths < 0) {
    return null
  }

  if (totalMonths < 12) {
    return { unit: 'months', count: totalMonths }
  }
  return { unit: 'years', count: Math.floor(totalMonths / 12) }
}

export function formatParticipantFullName(resolvedTitle: string | null, firstName: string | undefined, lastName: string | undefined): string {
  return [resolvedTitle, firstName, lastName].filter(Boolean).join(' ')
}

export function getExtraParticipantServices(overviewServices: OverviewService[], participantId: string): OverviewService[] {
  const participantServices: OverviewService[] = []
  for (const service of overviewServices) {
    const lines = service.lines.filter(line => line.participantIds?.includes(parseInt(participantId)) && line.isIncluded === false)
    if (lines.length > 0) {
      participantServices.push({ ...service, lines })
    }
  }
  return participantServices
}